import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f6a2cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["width", "height"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  fill: "none",
  "stroke-width": "6",
  "stroke-linecap": "round",
  cx: "33",
  cy: "33",
  r: "30"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1),
    (_openBlock(), _createElementBlock("svg", {
      class: "spinner",
      width: _ctx.size ? _ctx.size : '20px',
      height: _ctx.size ? _ctx.size : '20px',
      viewBox: "0 0 66 66",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_5, 8, _hoisted_3))
  ]))
}